import {useEffect, useState} from "react";
import axios from "axios";
import {useNewProduct} from "../../../store/contexts/NewProductContext";
import {TYPES} from "../../../store/reducers/NewProductReducer";

const StatusCard = () => {
  const [productStatuses, setProductStatuses] = useState([]);
  const {product, dispatch, errors} = useNewProduct();

  useEffect(() => {
    axios.get('/statuses/products').then(response => {
      setProductStatuses(response.data.statuses);
    })
  }, []);

  return (
    <div className="card card-flush py-4">
      <div className="card-header">
        <div className="card-title">
          <h2>Status</h2>
        </div>

        <div className="card-toolbar">
          <div className="rounded-circle bg-success w-15px h-15px"
               id="kt_ecommerce_add_product_status"></div>
        </div>
      </div>

      <div className="card-body pt-0">
        <div>
          <label className="form-label required">Status</label>
          <select className="form-select mb-2" data-control="select2" data-hide-search="true"
                  data-placeholder="Select an option" id="kt_ecommerce_add_product_status_select"
                  value={product?.status}
                  onChange={event => dispatch({
                    type: TYPES.SET_PRODUCT,
                    payload: {...product, status: event.target.value}
                  })}>
            <option value=''>Select Status</option>
            {productStatuses.map((item) => {
              return <option key={item.id} value={item.id}> {item.name}</option>
            })}
          </select>

          {
            errors?.status && (
              <div className="fs-7 mb-7 text-danger">{errors.status}</div>
            )
          }
        </div>

        <div className="mt-10">
          <label className="form-label">Ignore for delete</label>
          <select className="form-select mb-2" data-control="select2" data-hide-search="true"
                  data-placeholder="Select an option" id="kt_ecommerce_add_product_status_select"
                  value={product?.ignore_for_delete}
                  onChange={event => dispatch({
                    type: TYPES.SET_PRODUCT,
                    payload: {...product, ignore_for_delete: event.target.value}
                  })}>
            <option value=''>Select</option>
            <option value={true}>True</option>
            <option value={false}>False</option>
          </select>

          {
            errors?.ignore_for_delete && (
              <div className="fs-7 mb-7 text-danger">{errors.ignore_for_delete}</div>
            )
          }
        </div>
      </div>
    </div>
  )
}

export default StatusCard;